import { useState } from 'react';
import styled from '@emotion/styled';

import { Link } from 'react-router-dom';

import { Grid, Card, CardHeader, CardContent, CardActions, Button, Typography, Divider } from '@mui/material';

import { CardBlockContainer, CardBlock, CardBlockHeader, CardSpacer } from '../../../utils/utilities/CardComponents';

import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import AccountBoxOutlinedIcon from '@mui/icons-material/AccountBoxOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import AutoFixHighRoundedIcon from '@mui/icons-material/AutoFixHighRounded';

import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import AssuredWorkloadRoundedIcon from '@mui/icons-material/AssuredWorkloadRounded';
import PaymentsRoundedIcon from '@mui/icons-material/PaymentsRounded';
import TodayRounded from '@mui/icons-material/TodayRounded';
import Person3Rounded from '@mui/icons-material/Person3Rounded';
import AccessTimeRounded from '@mui/icons-material/AccessTimeRounded';
import PaidRoundedIcon from '@mui/icons-material/PaidRounded';
import LocalOfferRoundedIcon from '@mui/icons-material/LocalOfferRounded';
import LabelRoundedIcon from '@mui/icons-material/LabelRounded';
import VerifiedRoundedIcon from '@mui/icons-material/VerifiedRounded';

import { BasicFlex, Notes, LabelUpper } from '../../../utils/Common';

import SimpleChip from '../../../utils/utilities/SimpleChip';

import MultiStatusChip from '../../../utils/utilities/MultiStatusChip';

// use pageData context
import { usePageData } from '../../../contexts/PageData';

import { formatCurrency, formatPhoneNumber, formatGenericDateTime, formatGenericTime } from '../../../utils/util';

import NoTimeline from '../../../utils/utilities/Timeline/NoTimeline';

import TimelineWithComments from '../../../utils/utilities/Timeline/TimelineWithComments';

import ProfileBar from '../../../utils/utilities/ProfileBar';
import AppointmentStatus from '../Components/AppointmentStatus';
import ModifyAppointment from '../Components/ModifyAppointment';

import { CheckoutContext } from '../../../contexts/Checkout';
import Dialog from '../../../utils/utilities/Dialog';
import EditCheckout from '../../Checkout/EditCheckout';

import EditSchedule from '../../Schedule/EditSchedule';
import { useNewEvent } from '../../../contexts/NewEvent';


const DetailsTab = () => {
  const { data = {} } = usePageData();

  const [appointment, setAppointment] = useState(null);

  const { event, openDialog, setOpenDialog } = useNewEvent() || {};

  let service = data?.services?.find(el => el.appointment_id?.toString() == data.appointment_id?.toString());

  console.log(data?.services, service, "services");

  const basic_details = [
    { header: "Appointment", icon: <TodayRounded fontSize="small" color="basic" />, info: `${formatGenericTime(data.start_time)} - ${formatGenericTime(data.end_time)}`, spread: "12rem" },
    {
      header: "Stylist", icon: <Person3Rounded fontSize="small" color="basic" />, info: <SimpleChip label={data.stylist_name} />, spread: "12rem"
    },
    {
      header: "Duration", icon: <AccessTimeRounded fontSize="small" color="basic" />, info: `${data.duration_in_minutes} minutes`
    },
    {
      header: "Price", icon: <PaidRoundedIcon fontSize="small" color="basic" />, info: formatCurrency(data.subtotal)
    }
  ]

  const serviceBlock = [
    {
      header: "Wig ID", icon: <LocalOfferRoundedIcon fontSize='small' color="basic" />, info: data.wig_id
    },
    {
      header: "Wig Source", icon: <LabelRoundedIcon fontSize='small' color="basic" />, info: data.wig_source
    },
    {
      header: "Service Status", icon: <VerifiedRoundedIcon fontSize='small' color="basic" />, info: <MultiStatusChip value={data.status} values={[{ label: "Scheduled", value: "scheduled", status: "primary" }, { label: "In Progress", value: "in_progress", status: "warning" }, { label: "Completed", value: "completed", status: "success" }]} />
    }
  ]

  const invoice_details = [
    {
      header: "Invoice #", icon: <PaymentsRoundedIcon fontSize='small' color="basic" />, info: data.invoice_num
    },
    {
      header: "Total", icon: <AccountBalanceWalletOutlinedIcon fontSize='small' color="basic" />, info: formatCurrency(data.invoice_total)
    },
    {
      header: "Invoice Status", icon: <VerifiedRoundedIcon fontSize='small' color="basic" />, info: <MultiStatusChip value={data.invoice_status} values={[{ label: "Paid", value: "paid", status: "success" }, { label: "Unpaid", value: "unpaid", status: "error" }, { label: "Partially Paid", value: "partially_paid", status: "warning" }]} />
    },
    {
      header: "Balance", icon: <AssuredWorkloadRoundedIcon fontSize='small' color="basic" />, info: formatCurrency(data.invoice_balance)
    }
  ]

  const meta_details = [
    { header: "Created At", info: formatGenericDateTime(data.created_at) },
    {
      header: "Created By", info: <SimpleChip label={data.user_created} />
    }
  ]

 

  return (
    <CheckoutContext.Provider value={{ appointment, setAppointment }}>
    <Grid container spacing={3}>
      <Grid size={{xs: 12, md: 6}}>
        <Card variant='outlined'>
          <CardHeader 
          title={(
            <BasicFlex justify="flex-start" gap=".5rem">
              <div><AutoFixHighRoundedIcon /></div>
              <div>{data.title}</div>
            </BasicFlex>
            )}
            subheader={formatGenericDateTime(data.start_time)}
            action={<AppointmentStatus event={data} displayText={true} raised={false} />}
          />
            <Divider />
              <ProfileBar name={data.customer_name} phone={data.customer_phone} event={data} />
            <Divider />
          <CardContent sx={{pt: 0}}>
            <CardBlockContainer>
              <CardSpacer />
              <CardBlockHeader>Basic Details</CardBlockHeader>
              {basic_details.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              <CardSpacer />
              <CardBlockHeader>Service Details</CardBlockHeader>
              {serviceBlock.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}

              {data.invoice_id && (
                <>
                  <CardSpacer />
                  <CardBlockHeader>Invoice Details</CardBlockHeader>
                  {invoice_details.map((block) => (
                    <CardBlock key={block.header} {...block} />
                  ))}
                </>
              )}

              <CardSpacer />
              <CardBlockHeader>Log Details</CardBlockHeader>
              {meta_details.map((block) => (
                <CardBlock key={block.header} {...block} />
              ))}
        
            </CardBlockContainer>
          </CardContent>
          <Divider />

          <CardActions sx={{justifyContent: "flex-end"}}>
            <ModifyAppointment event={data} />
          </CardActions>

        </Card>

          <Dialog size="xl" title="Schedule Appointment" forceOpen={openDialog} forceClose={() => setOpenDialog(false)} text="" saveText="Add New Appointment" saveFunc={() => {}} useForm={true}>
            <EditSchedule dialog={true} event={event} />
          </Dialog>
      </Grid>

      <Grid size={{xs: 12, md: 6}}>
        <BasicFlex dir="column" gap="2.4rem">

          <Card variant='outlined' sx={{width: "100%"}}>
            <CardHeader title={<BasicFlex gap="1rem">Appointment Details </BasicFlex>} />
            <CardContent>
              <LabelUpper $normal $size="1.2rem">Service Notes</LabelUpper>
              <Notes>
                "{service?.notes}"
              </Notes>
            </CardContent>
          </Card>

          <Card variant='outlined' sx={{width: "100%"}}>
            <CardHeader title={<BasicFlex gap="1rem">Appointment History <HistoryRoundedIcon /></BasicFlex>} />
            <CardContent>
              <TimelineWithComments resource="appointment" resource_id={data.appointment_id} />
            </CardContent>
          </Card>
        </BasicFlex>
       
      </Grid>

    </Grid>

    <Dialog 
      fullScreen 
      forceOpen={appointment?.appointment_id ? true : false} 
      title="Appointment Checkout" 
      useForm={true} 
      forceClose={() => setAppointment(null)}
    >
      <EditCheckout />
    </Dialog>
    </CheckoutContext.Provider>
  );

};

export default DetailsTab;